<template>
    <div class="flex justify-center	items-center text-xs text-gray-500 bg-white border border-solid border-gray-100 rounded-full shadow-md" :class="chevronSize">
        <fa-icon :icon="icon" :size="iconSize"/>
    </div>
</template>

<script>

export default {
    name: 'CarouselChevron',
    props: {
        icon: {
            required: true
        },
        size: {
            required: false,
            default: 'lg'
        }
    },
    computed: {
        chevronSize() {
            switch (this.size) {
                case 'xs':
                    return 'w-4 h-4'
                case 'sm':
                    return 'w-6 h-6'
                case 'md':
                    return 'w-8 h-8'
                case 'lg':
                    return 'w-12 h-12'
                case 'xl':
                    return 'w-14 h-14'
                default:
                    return 'w-12 h-12'
            }
        },
        // Font Awesome has no "md"; map button size to a valid FA size.
        iconSize() {
            switch (this.size) {
                case 'xs':
                    return 'xs'
                case 'sm':
                case 'md':
                    return 'sm'
                case 'xl':
                    return 'xl'
                case 'lg':
                default:
                    return 'lg'
            }
        },
    }
}

</script>